// extracted by mini-css-extract-plugin
export var heroImage = "_gi-1";
export var modal = "_gi-0";